import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Item from "../../../../../../components/wizard/Item/Item";
import StatusChip from "./StatusChip";
import { getDisplayRackLocations, getWarehouseId } from "src/utils/internalWorkOrderRackLocations";
import { getLocationNames, getMobileLocationName } from "src/utils/rackLocations";

const styles = {
  chip: {
    backgroundColor: "action.hover",
    borderRadius: 1,
  },
  rackChip: {
    backgroundColor: "action.hover",
    borderRadius: 1,
    fontWeight: 500,
  },
};

export default function InternalWorkOrderItem({ value, project, warehouses, onSelect }) {
  const rackLocations = getDisplayRackLocations({ item: value });
  const itemWarehouses = rackLocations
    .map(getWarehouseId)
    .map(warehouseId => warehouses.find(w => w.warehouseId === warehouseId))
    .filter(Boolean);

  const rackLocationLabels = rackLocations.map(rl => {
    const locationNames = getLocationNames(rl);
    if (locationNames.length === 0) return null;
    return `${locationNames.join(", ")} (${rl.sub_qty})`;
  }).filter(Boolean);

  const mobileLocationLabels = [
    ...new Set(
      rackLocations
        .map(getMobileLocationName)
        .filter(Boolean)
    ),
  ];

  const showWarehouseNames = warehouses.length > 1;

  const handleClick = () => {
    onSelect(value);
  };

  return (
    <>
      <Item
        key={value.id}
        value={value}
        project={project}
        info={
          <>
            {value.nonAllocating ? (
              <Box fontWeight={500} fontSize="1.0rem">
                Non-allocating
              </Box>
            ) : value.quantity === 0 ? (
              <Box color="red" fontWeight={500} fontSize="1.0rem">
                Expected Quantity: {value.expectedQuantity || 0}
              </Box>
            ) : (
              <Box fontWeight={500} fontSize="1.0rem">
                Quantity: {value.quantity}
              </Box>
            )}
            <Box display="flex" gap={0.75} mt={1} flexWrap="wrap">
              <StatusChip
                label={value.pickedStatus ? "Staged" : "Pending Staging"}
                color={value.pickedStatus ? "success" : "pending"}
              />
              {value.pickedStatus && (
                <StatusChip
                  label={value.completedStatus ? "Returned to Storage" : "Pending Completion"}
                  color={value.completedStatus ? "success" : "pending"}
                />
              )}
            </Box>
          </>
        }
        actions={
          <Box
            display="flex"
            flexDirection="column"
            alignSelf="center"
            gap={0.5}
            alignItems={{ xs: "flex-start", sm: "flex-end" }}
          >
            {rackLocationLabels.length > 0 && (
              <Box display="flex" gap={0.5} flexWrap="wrap" justifyContent="flex-end">
                {rackLocationLabels.map((label, index) => (
                  <Chip key={`rack-${index}`} label={label} size="small" sx={styles.rackChip} />
                ))}
              </Box>
            )}
            {mobileLocationLabels.length > 0 && (
              <Box display="flex" flexDirection="column" alignItems="flex-end" gap={0.25}>
                {mobileLocationLabels.map((label, index) => (
                  <Box key={`mobile-${index}`} fontSize="0.75rem" color="text.secondary">
                    {label}
                  </Box>
                ))}
              </Box>
            )}
            {showWarehouseNames && itemWarehouses.length > 0 && (
              <Box display="flex" gap={0.5} flexWrap="wrap" justifyContent="flex-end">
                {itemWarehouses.map((warehouse, index) => (
                  <Chip key={`warehouse-${index}`} label={warehouse.name} size="small" sx={styles.chip} />
                ))}
              </Box>
            )}
          </Box>
        }
        onClick={handleClick}
      />
    </>
  );
}
